/**
The main entry point for a Product

Referenced by product.*.liquid templates.
* */
import React from 'react';
import ReactDOM from 'react-dom';
import './scss/templates/product.scss';
import OVApp from './utils/OVContext';
import Product from './apps/product/ProductLoader';
import { jsx as _jsx } from "react/jsx-runtime";

var init = function init() {
  var _window$OV$PARENT_PRO = window.OV.PARENT_PRODUCT,
      handle = _window$OV$PARENT_PRO.handle,
      id = _window$OV$PARENT_PRO.id,
      split = _window$OV$PARENT_PRO.split;
  var _window$location = window.location,
      pathname = _window$location.pathname,
      search = _window$location.search;
  var params = new URLSearchParams(search);
  var productEl = document.getElementById('product-detail');
  var shopifyVariantId = params.get('variant');
  var colorwayHandle = pathname.replace('/products/', '');
  var sizeSelected = params.get('size');
  ReactDOM.render( /*#__PURE__*/_jsx(OVApp, {
    children: /*#__PURE__*/_jsx(Product, {
      colorwayHandle: colorwayHandle,
      handle: handle,
      id: id,
      loading: productEl.innerHTML,
      shopifyVariantId: shopifyVariantId ? parseInt(shopifyVariantId, 10) : false,
      sizeSelected: sizeSelected === '1',
      split: split
    })
  }), productEl);
};

init();